<div class="orcaa-wrapper">

    <!-- HEADER -->
    <h2 class="fw-bold gradient-text">Orcaa AI</h2>
    <p class="text-muted mb-4">
      Test learning intelligence instantly. Upload documents or enter text to see AI-powered insights.
    </p>

    <!-- TOP METRIC CARDS -->
    <div class="row g-3 mb-3">

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-primary">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Automation</span>
                        <i class="fa-solid fa-magic text-primary"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">AI</div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-success">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Data Sync</span>
                        <i class="fa-solid fa-refresh text-success"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Live</div>
                </div>
            </div>
        </div>


        <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">AI Analysis</span>
                        <i class="fa-solid fa-line-chart gradient-text"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">Instant</div>
                </div>
            </div>
        </div>

       <div class="col-12 col-sm-6 col-lg-3">
            <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-warning">
                <div class="card-body p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <span class="text-muted small">Use Cases</span>
                        <i class="fa-solid fa-suitcase text-warning"></i>
                    </div>
                    <div class="h4 fw-bold mb-0">All</div>
                </div>
            </div>
        </div>

    </div>

    <!-- FEATURE CARDS (PERFECT 2×2 GRID) -->
    <div class="row g-4">

      <!-- CARD 1 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-table gradient-text"></i>
            </div>
            <h5 class="fw-bold">Generate Full Courses With AI</h5>
          </div>

          <p class="text-muted feature-body">
            Upload notes, documents, videos, or simply type the key topics.
            Orcaa instantly turns your content into a complete, structured course — including modules, lessons, summaries, activities, and optional assessments.
          </p>

          <button class="btn upload-button w-100" @click="launch_workspace('courses')">
            <i class="bi bi-upload me-2"></i>Generate Course
          </button>

        </div>
      </div>

      <!-- CARD 2 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-commenting gradient-text"></i>
            </div>
            <h5 class="fw-bold">Auto-Generate Assessments for Any Topic</h5>
          </div>

          <div class="feature-body">
            <p class="text-muted">
              Enter a topic or upload learning content.
              Orcaa creates assessments with questions, answers, difficulty levels, rubrics, and scoring guides.
            </p>

          </div>

          <button class="btn upload-button w-100 mt-3" @click="launch_workspace('assessments')">
            Generate Assessment
          </button>

        </div>
      </div>

      <!-- CARD 3 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-book gradient-text"></i>
            </div>
            <h5 class="fw-bold">Upload Documents → Extract Key Information</h5>
          </div>

          <p class="text-muted feature-body">
            Upload reports, logbooks, PDFs, or assignments.
            Orcaa extracts skills, tasks, hours, outcomes, and structured insights instantly.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Upload Document
          </button>

        </div>
      </div>

      <!-- CARD 4 -->
      <div class="col-md-6">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-bar-chart gradient-text"></i>
            </div>
            <h5 class="fw-bold">Enhance Notes, Videos & Learning Content</h5>
          </div>

          <p class="text-muted feature-body">
            Improve clarity, structure, and engagement.
            Orcaa enhances your content with summaries, rewritten notes, topic breakdowns, and learning-ready formats.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Enhance Content
          </button>

        </div>
      </div>

      <!-- CARD 5 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-upload gradient-text"></i>
            </div>
            <h5 class="fw-bold">Upload CSV → Auto-Dashboard Creation</h5>
          </div>

          <p class="text-muted feature-body">
            Upload learner data, marks, or attendance.
            AI generates skills heatmaps and trend insights instantly.
          </p>

          <button class="btn upload-button w-100">
            <i class="bi bi-upload me-2"></i>Upload File
          </button>

        </div>
      </div>

      <!-- CARD 6 -->
      <div class="col-md-6 d-none">
        <div class="card feature-card shadow-sm p-4 d-flex flex-column">

          <div class="feature-head">
            <div class="feature-icon d-flex align-items-center justify-content-center">
              <i class="fa-solid fa-user gradient-text"></i>
            </div>
            <h5 class="fw-bold">Personalised Learning Path from One Sentence</h5>
          </div>

          <div class="feature-body">
            <p class="text-muted">
              Describe your learning goal.
              AI creates a complete learning path with modules and time estimates.
            </p>

          </div>

          <button class="btn upload-button w-100 mt-3">
            Generate AI Insights
          </button>

        </div>
      </div>

    </div>

  </div>